<template>
  <div id="payments">
    <div class="row">
      <div class="col-12 d-flex justify-content-between flex-wrap">
        <div style="flex:1;" class="d-flex align-items-center">
          <h2 class="view-title">Planes y pagos</h2>
        </div>
        <div
          class="container-actions-dashboard d-flex justify-content-end mt-2 mt-sm-2 mt-md-0 mt-lg-0 mt-xl-0"
        >
          <router-link
            class="btn btn-outlined d-flex align-items-center"
            to="/configuracion"
          >
            <img src="@/assets/icons/undo.svg" width="15px" class="mr-2" />
            Regresar a configuración
          </router-link>
          <button
            type="submit"
            class="btn btn-save ml-2 d-flex align-items-center"
            @click="validateFacturar()"
          >
            <img src="@/assets/icons/guardar.svg" width="20" class="mr-2" />
            Guardar cambios
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-2">
        <p class="content-text">
          Visualiza tu historial de pagos y el plan en el que te encuentras. Si
          tienes un plan de pago mensual, puedes cambiar de plan cuando quieras,
          este se actualizará en tu siguiente fecha de cobro. Si tienes un plan
          anual, tendrás que esperar a que termine el plazo del año que
          contrataste.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-4 col-lg-6 col-md-6">
        <div class="cotizarlo-general-wrapper wrapper-padding">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-12">
                <div class="d-flex align-items-center mb-3">
                  <h3 class="subtitle-section my-0">Tu plan actual</h3>
                  <span
                    class="ml-2 icon-cot-info"
                    v-tooltip="
                      'Cambiar tu método de pago o plan no afectará tu mes o año en curso.  Si ya tenías pagado un plan y realizas un cambio, tomaremos el remanente como saldo.'
                    "
                  ></span>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div
                class="col-12 text-center"
                v-if="planDetails.plan_detail != null"
              >
                <div
                  v-if="
                    planDetails.plan_detail.status == 'active' ||
                      planDetails.plan_detail.status == 'trialing'
                  "
                >
                  <img
                    class="img-fluid"
                    src="@/assets/images/plans/basic_free.png"
                    v-if="planDetails.plan_type == 1"
                  />
                  <img
                    class="img-fluid"
                    src="@/assets/images/plans/personal_monthly.png"
                    v-if="
                      planDetails.plan_type == 2 &&
                        planDetails.plan_frecuency == 1
                    "
                  />
                  <img
                    class="img-fluid"
                    src="@/assets/images/plans/personal_yearly.png"
                    v-if="
                      planDetails.plan_type == 2 &&
                        planDetails.plan_frecuency == 2
                    "
                  />
                  <img
                    class="img-fluid"
                    src="@/assets/images/plans/team_monthly.png"
                    v-if="
                      planDetails.plan_type == 3 &&
                        planDetails.plan_frecuency == 1
                    "
                  />
                  <img
                    class="img-fluid"
                    src="@/assets/images/plans/team_yearly.png"
                    v-if="
                      planDetails.plan_type == 3 &&
                        planDetails.plan_frecuency == 2
                    "
                  />
                </div>
                <div v-else>
                  <img
                    class="img-fluid"
                    src="@/assets/images/plans/error/personal_monthly.png"
                    v-if="
                      planDetails.plan_type == 2 &&
                        planDetails.plan_frecuency == 1
                    "
                  />
                  <img
                    class="img-fluid"
                    src="@/assets/images/plans/error/personal_yearly.png"
                    v-if="
                      planDetails.plan_type == 2 &&
                        planDetails.plan_frecuency == 2
                    "
                  />
                  <img
                    class="img-fluid"
                    src="@/assets/images/plans/error/team_monthly.png"
                    v-if="
                      planDetails.plan_type == 3 &&
                        planDetails.plan_frecuency == 1
                    "
                  />
                  <img
                    class="img-fluid"
                    src="@/assets/images/plans/error/team_yearly.png"
                    v-if="
                      planDetails.plan_type == 3 &&
                        planDetails.plan_frecuency == 2
                    "
                  />
                </div>
              </div>
              <div class="col-12 text-center" v-else>
                <img
                  class="img-fluid"
                  src="@/assets/images/plans/basic_free.png"
                  v-if="planDetails.plan_type == 1"
                />
                <img
                  class="img-fluid"
                  src="@/assets/images/plans/personal_monthly.png"
                  v-if="
                    planDetails.plan_type == 2 &&
                      planDetails.plan_frecuency == 1
                  "
                />
                <img
                  class="img-fluid"
                  src="@/assets/images/plans/personal_yearly.png"
                  v-if="
                    planDetails.plan_type == 2 &&
                      planDetails.plan_frecuency == 2
                  "
                />
                <img
                  class="img-fluid"
                  src="@/assets/images/plans/team_monthly.png"
                  v-if="
                    planDetails.plan_type == 3 &&
                      planDetails.plan_frecuency == 1
                  "
                />
                <img
                  class="img-fluid"
                  src="@/assets/images/plans/team_yearly.png"
                  v-if="
                    planDetails.plan_type == 3 &&
                      planDetails.plan_frecuency == 2
                  "
                />
              </div>
            </div>

            <!-- Seccion de detalles de plan -->
            <subscription-info :subscriptionDetail="currentPlantData" />

            <div class="row mt-2" v-if="planDetails.plan_detail != null">
              <div
                class="col-12"
                v-if="planDetails.plan_detail.cancel_at_period_end == true"
              >
                <span class="text-danger"
                  >Tu suscripción ha sido cancelada, y podrás gozar de sus
                  privilegios hasta el día
                  {{ planDetails.plan_detail.next_charge }}</span
                >
              </div>
            </div>

            <div class="row mt-2" v-if="planDetails.plan_type == 1">
              <div class="col-12">
                <div class="d-flex justify-content-around">
                  <button
                    type="button"
                    class="btn btn-simple btn-sm text-uppercase mr-2"
                    @click="ShowModalSubscriptions()"
                  >
                    Contratar plan
                  </button>
                  <button
                    type="button"
                    class="btn btn-outlined btn-sm text-uppercase"
                    @click="ShowModalSubscriptions()"
                  >
                    Ver planes y precios
                  </button>
                </div>
              </div>
            </div>

            <div class="row mt-2" v-if="planDetails.plan_type != 1">
              <div class="col-12">
                <div class="d-flex justify-content-around">
                  <button
                    type="button"
                    class="btn btn-simple btn-sm text-uppercase mr-2"
                    @click="ShowModalSubscriptions()"
                  >
                    Cambiar plan
                  </button>
                  <div v-if="planDetails.plan_detail != null">
                    <button
                      type="button"
                      v-bind:class="{
                        'btn-warning':
                          planDetails.plan_detail.status != 'active' &&
                          planDetails.plan_detail.status != 'trialing',
                        'btn-outlined':
                          planDetails.plan_detail.status == 'active' ||
                          planDetails.plan_detail.status == 'trialing',
                      }"
                      class="btn btn-sm text-uppercase"
                      @click="showModalPaymentMethod()"
                      v-if="
                        planDetails.plan_detail.cancel_at_period_end == false
                      "
                    >
                      Cambiar método de pago
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="row mt-4"
              v-if="
                planDetails.plan_type != 1 &&
                  !planDetails.plan_detail.cancel_at_period_end &&
                  planDetails.plan_detail != null
              "
            >
              <div class="col-12">
                <div
                  style="cursor:pointer;"
                  @click="showModalCancelSubscription()"
                >
                  <i class="fas fa-ban text-danger"></i>
                  <span class="text-danger ml-1">Cancelar suscripción</span>
                </div>
              </div>
            </div>

            <!-- Modal detalles de plan -->
            <subscriptions-detail
              :subscriptions="subscriptions"
            ></subscriptions-detail>
            <!-- Modal change payment method -->
            <subscription-change-payment-method
              v-if="planDetails.plan_type != 1"
            ></subscription-change-payment-method>
            <!-- Modal cancel Subscription -->
            <subscription-cancel></subscription-cancel>
          </div>
        </div>
      </div>
      <div class="col-xl-8 col-lg-6 col-md-6">
        <div class="row">
          <!-- Facturas -->
          <div
            class="col-xl-6 col-lg-12 mt-xl-0 mt-lg-0 mt-md-0 mt-sm-3 mt-3"
            v-if="invoicesInfo.total > 0"
          >
            <div class="cotizarlo-general-wrapper wrapper-padding">
              <div class="card-body p-0">
                <div class="row mb-2">
                  <div class="col-12">
                    <div class="d-flex align-items-center mb-3">
                      <h3 class="subtitle-section my-0">Pagos realizados</h3>
                      <span
                        class="ml-2 icon-cot-info"
                        v-tooltip="
                          'Descarga todos tus recibos de pago como hoja de cálculo o individualmente como pdf.'
                        "
                      ></span>
                    </div>
                  </div>
                </div>
                <div
                  v-for="(invoice, index) in invoicesInfo.records"
                  :key="index"
                >
                  <div class="row">
                    <div class="col-12">
                      <div class="d-flex w-100">
                        <div>
                          {{ invoice.date }}
                        </div>
                        <div class="ml-auto">
                          <a
                            :href="invoice.link_pdf"
                            style="text-decoration:none; color:black;"
                          >
                            <span
                              class="icon-cot-pdf"
                              style="font-size:1.5rem;"
                            ></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr class="my-2" />
                </div>
                <div class="row">
                  <div class="col-10 offset-1">
                    <div class="d-flex mt-2">
                      <button
                        type="button"
                        v-if="invoicesInfo.next_page_url != null"
                        class="btn btn-simple btn-sm text-uppercase mr-2"
                      >
                        Ver más
                      </button>
                      <export-excel :data="invoicesInfo.records">
                        <button
                          type="button"
                          class="btn btn-outlined btn-sm text-uppercase"
                        >
                          Descargar todos en xls
                        </button>
                      </export-excel>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Facturacion devolver condicion de factura -->
          <div
            class="col-xl-6 col-lg-12 mt-xl-0 mt-lg-3 mt-md-3 mt-sm-3 mt-3"
            v-if="
              this.userRole !== 'Gratis' &&
                this.company.team.country.code === 'MX'
            "
          >
            <div class="cotizarlo-general-wrapper wrapper-padding">
              <div class="card-body p-0">
                <div class="row mb-2">
                  <div class="col-12">
                    <div class="d-flex align-items-center mb-3">
                      <h3 class="subtitle-section my-0">
                        Datos de facturación
                      </h3>
                      <span
                        class="ml-2 icon-cot-info"
                        v-tooltip="
                          'Activa la facturación automática y llena los datos para recibir facturas con cada cobro realizado. Si realizaste tu pago previo a la activación de esta funcionalidad (y en el mes en curso), escríbenos a soporte@cotizarlo.com con tus datos para enviártela manualmente. '
                        "
                      ></span>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-12">
                    <div class="d-flex align-items-center mb-3 mr-2">
                      <label class="switch m-0 flex-shrink-0">
                        <input type="checkbox" v-model="useAutoFacture" />
                        <span class="slider round"></span>
                      </label>
                      <span class="ml-2">Activar facturación automática</span>
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <input
                        type="text"
                        class="input-no-label form-control"
                        :class="{
                          'is-invalid': $v.facturacionData.legal_name.$error,
                        }"
                        v-model="facturacionData.legal_name"
                        placeholder="Razón social"
                      />
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <input
                        type="text"
                        class="input-no-label form-control"
                        :class="{
                          'is-invalid': $v.facturacionData.tax_id.$error,
                        }"
                        v-model="facturacionData.tax_id"
                        placeholder="RFC"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <select
                        class="input-append custom-select"
                        style="border-radius:12px;padding:12px 15px;height:auto;"
                        :class="{
                          'is-invalid': $v.facturacionData.tax_regime.$error,
                        }"
                        v-model="facturacionData.tax_regime"
                      >
                        <option value="Persona Física">Persona Física</option>
                        <option value="Persona Moral">Persona Moral</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <input
                        type="email"
                        class="input-no-label form-control"
                        :class="{
                          'is-invalid': $v.facturacionData.email.$error,
                        }"
                        v-model="facturacionData.email"
                        placeholder="Email de facturación"
                      />
                      <small
                        class="form-text text-danger"
                        v-show="!$v.facturacionData.email.email"
                        >Ingresa un email válido</small
                      >
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <select
                        class="input-append custom-select"
                        style="border-radius:12px;padding:12px 15px;height:auto;"
                        :class="{
                          'is-invalid': $v.facturacionData.use_cfdi.$error,
                        }"
                        v-model="facturacionData.use_cfdi"
                      >
                        <option value="">Uso del CFDI</option>
                        <option
                          v-for="(cfdi, index) in cfdiOptions"
                          :key="index"
                          v-bind:value="cfdi.value"
                        >
                          {{ cfdi.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <input
                        type="text"
                        class="input-no-label form-control"
                        :class="{
                          'is-invalid': $v.facturacionData.telephone.$error,
                        }"
                        v-model="facturacionData.telephone"
                        placeholder="Teléfono"
                      />
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <select
                        class="input-append custom-select"
                        style="border-radius:12px;padding:12px 15px;height:auto;"
                        :class="{
                          'is-invalid': $v.facturacionData.country_id.$error,
                        }"
                        v-model="facturacionData.country_id"
                      >
                        <option value="">Selecciona un país</option>
                        <option
                          v-for="(country, index) in countriesList"
                          :key="index"
                          v-bind:value="country.id"
                        >
                          {{ country.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <input
                        type="text"
                        class="input-no-label form-control"
                        :class="{
                          'is-invalid': $v.facturacionData.state.$error,
                        }"
                        v-model="facturacionData.state"
                        placeholder="Estado"
                      />
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <input
                        type="text"
                        class="input-no-label form-control"
                        :class="{
                          'is-invalid': $v.facturacionData.city.$error,
                        }"
                        v-model="facturacionData.city"
                        placeholder="Ciudad"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <input
                        type="text"
                        class="input-no-label form-control"
                        :class="{
                          'is-invalid': $v.facturacionData.street.$error,
                        }"
                        v-model="facturacionData.street"
                        placeholder="Calle"
                      />
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <input
                        type="text"
                        class="input-no-label form-control"
                        :class="{
                          'is-invalid': $v.facturacionData.number_ext.$error,
                        }"
                        v-model="facturacionData.number_ext"
                        placeholder="Número exterior"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <input
                        type="text"
                        class="input-no-label form-control"
                        :disabled="useAutoFacture == false"
                        :class="{
                          'is-invalid': $v.facturacionData.zipcode.$error,
                        }"
                        v-model="facturacionData.zipcode"
                        placeholder="Código postal"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filters from "@/mixins/filters";
import data from "@/mixins/data";
import methods from "@/mixins/methods";
import { validationMixin } from "vuelidate";
import { email, requiredIf } from "vuelidate/lib/validators";
import plansService from "@/api/plans";
import clientService from "@/api/clients";
/* Import components */
import SubscriptionsDetail from "@/components/settings/payments_config/SubscriptionsDetail";
import SubscriptionInfo from "@/components/settings/payments_config/SubscriptionInfo";
import SubscriptionCancel from "@/components/settings/payments_config/SubscriptionCancel";
import SubscriptionChangePaymentMethod from "@/components/settings/payments_config/SubscriptionChangePaymentMethod";
import $ from "jquery";

export default {
  mixins: [filters, data, methods, validationMixin],
  components: {
    SubscriptionsDetail,
    SubscriptionInfo,
    SubscriptionChangePaymentMethod,
    SubscriptionCancel,
  },
  computed: {
    userSubscription() {
      var plan = "Básico";
      switch (this.planDetails.plan_type) {
        case 1:
          plan = "Básico";
          break;

        case 2:
          plan = "Personal";
          break;

        case 3:
          plan = "Equipo";
          break;
      }
      return plan;
    },
  },
  beforeMount() {
    $(".modal-backdrop").remove();
    this.$store.dispatch("showLoader", { show: true });

    this.getPlansData().then(() => {
      this.getInvoices().then(() => {
        this.getCountries().then((response) => {
          this.countriesList = response;
          this.$store.dispatch("showLoader", { show: false });
        });
      });
    });
    if (this.configuration.invoice != null) {
      this.useAutoFacture = this.configuration.send_invoice == 1 ? true : false;
      this.facturacionData.legal_name = this.configuration.invoice.legal_name;
      this.facturacionData.tax_id = this.configuration.invoice.tax_id;
      this.facturacionData.tax_regime = this.configuration.invoice.tax_regime;
      this.facturacionData.email = this.configuration.invoice.email;
      this.facturacionData.use_cfdi = this.configuration.invoice.use_cfdi;
      this.facturacionData.same_address = this.configuration.invoice.same_address;
      this.facturacionData.telephone = this.configuration.invoice.telephone;
      this.facturacionData.country_id = this.configuration.invoice.country_id;
      this.facturacionData.state = this.configuration.invoice.state;
      this.facturacionData.city = this.configuration.invoice.city;
      this.facturacionData.street = this.configuration.invoice.street;
      this.facturacionData.number_ext = this.configuration.invoice.number;
      this.facturacionData.zipcode = this.configuration.invoice.zipcode;
    }
  },
  beforeDestroy() {
    $(".modal-backdrop").remove();
  },
  data() {
    return {
      countriesList: [],
      useAutoFacture: false,
      facturacionData: {
        legal_name: null,
        tax_id: null,
        tax_regime: "Persona Física",
        email: null,
        use_cfdi: "",
        same_address: true,
        telephone: null,
        country_id: "",
        state: null,
        city: null,
        street: null,
        number_ext: null,
        zipcode: null,
      },
      subscriptions: [
        {
          name: "Básico",
          description:
            "Nuestro plan gratuito es increíble, pero ¡aún hay mucho más por descubrir! Te invitamos a conocer nuestros planes pagados, en donde podrás personalizar tus cotizaciones, enviar cotizaciones ilimitadas y todas desde tu propio correo.",
          images: [],
          prices: [
            {
              nickname: "Gratis Anual",
              price: "Gratis",
              currency: "mxn",
              recurring: "year",
            },
            {
              nickname: "Gratis Mensual",
              price: "Gratis",
              currency: "mxn",
              recurring: "month",
            },
          ],
        },
      ],
      currentPlantData: [
        {
          name: "",
          description: "",
          images: [],
          prices: [
            {
              nickname: "",
              price: "",
              currency: "",
              recurring: "",
            },
            {
              nickname: "",
              price: "",
              currency: "",
              recurring: "",
            },
          ],
        },
      ],
      invoicesInfo: {
        total: 0,
        per_page: 0,
        records: [],
        next_page_url: "",
        prev_page_url: "",
        first_page_url: "",
        last_page_url: "",
        from: 1,
        to: 1,
      },
    };
  },
  methods: {
    validateFacturar() {
      if (this.useAutoFacture != false) {
        this.$v.$touch();
        if (this.$v.facturacionData.$invalid) {
          this.$store.dispatch("showMessage", {
            action: "error",
            message: "Llena todos los campos requeridos",
          });
        } else {
          this.$store.dispatch("showLoader", { show: true });
          let dataToSend = { ...this.facturacionData };
          dataToSend.same_address = 0;
          plansService
            .saveFactureData(dataToSend)
            .then(() => {
              this.$store.dispatch("client/updateConfiguration").then(() => {
                this.useAutoFacture =
                  this.configuration.send_invoice == 1 ? true : false;
                this.facturacionData.legal_name = this.configuration.invoice.legal_name;
                this.facturacionData.tax_id = this.configuration.invoice.tax_id;
                this.facturacionData.tax_regime = this.configuration.invoice.tax_regime;
                this.facturacionData.email = this.configuration.invoice.email;
                this.facturacionData.use_cfdi = this.configuration.invoice.use_cfdi;
                this.facturacionData.same_address = this.configuration.invoice.same_address;
                this.facturacionData.telephone = this.configuration.invoice.telephone;
                this.facturacionData.country_id = this.configuration.invoice.country_id;
                this.facturacionData.state = this.configuration.invoice.state;
                this.facturacionData.city = this.configuration.invoice.city;
                this.facturacionData.street = this.configuration.invoice.street;
                this.facturacionData.number_ext = this.configuration.invoice.number;
                this.facturacionData.zipcode = this.configuration.invoice.zipcode;
                this.$store.dispatch("showLoader", { show: false });
                this.$store.dispatch("showMessage", {
                  action: "success",
                  message: "Datos guardados correctamente",
                });
              });
            })
            .catch(() => {
              this.$store.dispatch("showLoader", { show: false });
            });
        }
      } else {
        this.$store.dispatch("showLoader", { show: true });
        plansService
          .deactivateSendFacture()
          .then(() => {
            this.$store.dispatch("client/updateConfiguration").then(() => {
              this.$store.dispatch("showLoader", { show: false });
            });
          })
          .catch(() => {
            this.$store.dispatch("showLoader", { show: false });
          });
      }
    },
    getCountries() {
      return new Promise((resolve, reject) => {
        clientService
          .getCountriesList()
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((e) => reject(e));
      });
    },
    showModalCancelSubscription() {
      $("#cancelSubscription")
        .modal()
        .show();
    },
    getInvoices() {
      return new Promise((resolve, reject) => {
        plansService
          .listInvoices()
          .then((response) => {
            this.invoicesInfo.total = response.data.data.total;
            this.invoicesInfo.per_page = response.data.data.per_page;
            this.invoicesInfo.records = response.data.data.data;
            this.invoicesInfo.next_page_url = response.data.data.next_page_url;
            this.invoicesInfo.prev_page_url = response.data.data.prev_page_url;
            this.invoicesInfo.first_page_url =
              response.data.data.first_page_url;
            this.invoicesInfo.last_page_url = response.data.data.last_page_url;
            this.invoicesInfo.from = response.data.data.from;
            this.invoicesInfo.to = response.data.data.to;
            resolve(response.data.data.invoices);
          })
          .catch((e) => reject(e));
      });
    },
    isPlanActive(name) {
      return name == this.userSubscription ? true : false;
    },
    getPlansData() {
      return new Promise((resolve, reject) => {
        plansService
          .getPlansData()
          .then((response) => {
            response.data.data.forEach((element) => {
              element.name = element.name.replace("Plan ", "");
              this.subscriptions.push(element);
            });
            this.currentPlantData = this.subscriptions.filter(
              (element) => element.name == this.userSubscription
            );

            resolve(response);
          })
          .catch((e) => reject(e));
      });
    },
    ShowModalSubscriptions() {
      $("#subscriptionDetails")
        .modal()
        .show();
    },
    showModalPaymentMethod() {
      $("#modalChangePaymentMethod")
        .modal()
        .show();
    },
  },
  watch: {
    userSubscription(val) {
      this.currentPlantData = this.subscriptions.filter(
        (element) => element.name == val
      );
      this.getInvoices();
    },
  },
  validations: {
    facturacionData: {
      legal_name: {
        required: requiredIf(function() {
          return this.useAutoFacture == true;
        }),
      },
      tax_id: {
        required: requiredIf(function() {
          return this.useAutoFacture == true;
        }),
      },
      tax_regime: {
        required: requiredIf(function() {
          return this.useAutoFacture == true;
        }),
      },
      email: {
        required: requiredIf(function() {
          return this.useAutoFacture == true;
        }),
        email,
      },
      use_cfdi: {
        required: requiredIf(function() {
          return this.useAutoFacture == true;
        }),
      },
      same_address: {
        required: requiredIf(function() {
          return this.useAutoFacture == true;
        }),
      },
      telephone: {
        required: requiredIf(function() {
          return this.facturacionData.same_address == false;
        }),
      },
      country_id: {
        required: requiredIf(function() {
          return this.facturacionData.same_address == false;
        }),
      },
      state: {
        required: requiredIf(function() {
          return this.facturacionData.same_address == false;
        }),
      },
      city: {
        required: requiredIf(function() {
          return this.facturacionData.same_address == false;
        }),
      },
      street: {
        required: requiredIf(function() {
          return this.facturacionData.same_address == false;
        }),
      },
      number_ext: {
        required: requiredIf(function() {
          return this.facturacionData.same_address == false;
        }),
      },
      zipcode: {
        required: requiredIf(function() {
          return this.facturacionData.same_address == false;
        }),
      },
    },
  },
};
</script>
